//Service Worker https://angular.io/guide/service-worker-getting-started
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';

//Webstorage
import { StorageServiceModule} from 'angular-webstorage-service';

//Components
import { AppComponent } from './app.component';
import { NavbarComponent } from './modules/shared/navbar/navbar.component';
import { OrganizationalStructureComponent } from './organizational-structure/organizational-structure.component';

//Router
import { appRouter } from './app.router';

//GUARDS
import { PermissAccessPage } from './guards/permissAccessPage';

//Transalte Module
import { TranslateModule } from '@ngx-translate/core';
import { TranslateLoader } from '@ngx-translate/core';
import { HttpLoaderFactory, AppTranslateService } from './modules/shared/translate/translate.service';

//Bootstrap
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

//Device detector
import { DeviceDetectorModule } from 'ngx-device-detector';

//LOADING
import { NgxLoadingModule } from 'ngx-loading';

//Material
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatNativeDateModule, MatFormFieldModule, MatTreeModule, MatIconModule, MatInputModule, MatCheckboxModule } from '@angular/material';

//Font Awesome
import { Angular2FontawesomeModule } from 'angular2-fontawesome';

//Shared Modules
import { BreadCrumbModule } from './modules/shared/bread-crumb/bread-crumb.module';

//Shared Services
import { AppService } from './modules/shared/app-service/app-service.service';
import { WinAuthInterceptor } from './modules/shared/winauth-interceptor/winauth-interceptor';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { DialogsModule } from './modules/shared/dialogs/dialogs.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { InputDatepickerService } from './modules/shared/forms/input-datepicker/services/input-datepicker.service';
import { SnackBarService } from './modules/shared/snack-bar/snack-bar.service';
import { FormsService } from './modules/shared/forms/services/forms-service.service';
import { SelectListModule } from './modules/shared/forms/select-list/select-list.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginService } from './modules/login/services/login.service';
import { BeforeNavigationHome } from './guards/beforeNavigationHome';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    OrganizationalStructureComponent
  ],
  imports: [
    BrowserModule,
    ServiceWorkerModule.register('/ngsw-worker.js', {enabled: environment.production}),
    StorageServiceModule,
    appRouter,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgbModule.forRoot(),
    DeviceDetectorModule.forRoot(),
    NgxLoadingModule.forRoot({}),
    BreadCrumbModule,
    MatSnackBarModule,
    MatDialogModule,
    MatSidenavModule,
    Angular2FontawesomeModule,
    BrowserAnimationsModule,
    DialogsModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatTreeModule,
    MatIconModule,
    MatInputModule,
    MatCheckboxModule,
    SelectListModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WinAuthInterceptor,
      multi: true
    },
    PermissAccessPage,
    BeforeNavigationHome,
    AppTranslateService,
    InputDatepickerService,
    SnackBarService,
    FormsService,
    LoginService,
    AppService
  ],
  bootstrap: [
    AppComponent
  ],
  entryComponents: [
    OrganizationalStructureComponent
  ]
})
export class AppModule { }
